const H1_COLOR_VARS = {
  White: 'var(--white)',
  'Ginst yellow': 'var(--ginst-yellow)',
  'Ocean blue': 'var(--ocean-blue)',
  'Deep blue': 'var(--deep-blue)',
  Black: 'var(--black)',
};

const H1_COLOR_ALIASES = {
  white: 'White',
  vit: 'White',
  'ginst yellow': 'Ginst yellow',
  ginst: 'Ginst yellow',
  accent: 'Ginst yellow',
  accenture: 'Ginst yellow',
  'ocean blue': 'Ocean blue',
  ocean: 'Ocean blue',
  'deep blue': 'Deep blue',
  contrast: 'Deep blue',
  black: 'Black',
  svart: 'Black',
};

function normalizeH1ColorKey(value, defaultKey = 'White') {
  if (!value) {
    return H1_COLOR_VARS[defaultKey] ? defaultKey : 'White';
  }

  const trimmed = String(value).trim();

  if (H1_COLOR_VARS[trimmed]) {
    return trimmed;
  }

  return H1_COLOR_ALIASES[trimmed.toLowerCase()] || defaultKey;
}

export function getH1Color(value, defaultKey = 'White') {
  return H1_COLOR_VARS[normalizeH1ColorKey(value, defaultKey)];
}

export function getH1Style(value, defaultKey = 'White') {
  const color = getH1Color(value, defaultKey);

  return {
    '--hero-title-color': color,
    color,
    fontWeight: 400,
  };
}

export function getCollectionMainTitleStyle(value) {
  if (!value) {
    return undefined;
  }

  const trimmed = String(value).trim();
  const key = H1_COLOR_VARS[trimmed] ? trimmed : H1_COLOR_ALIASES[trimmed.toLowerCase()];

  if (!key || !H1_COLOR_VARS[key]) {
    return undefined;
  }

  return {color: H1_COLOR_VARS[key]};
}
